import { random, round2, round2Str } from "../helpers/helpers";

export const generateAhuLatestDashboardDemoData = (meterId = 1400, meterName = "Demo NBRI AHU") => {
    const now = new Date();
    const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${now.toLocaleString(
        'default',
        { month: 'short' }
    )}-${now.getFullYear().toString().slice(-2)} ${now
        .getHours()
        .toString()
        .padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;

    // Electrical
    const voltRN = random(238, 245);
    const voltYN = random(238, 245);
    const voltBN = random(238, 245);

    const currentR = random(0.5, 2.5);
    const currentY = random(0.5, 2.5);
    const currentB = random(0.5, 2.5);

    const avgVolt = round2((voltRN + voltYN + voltBN) / 3);
    const avgCurrent = round2((currentR + currentY + currentB) / 3);
    const pf = random(0.85, 0.98);

    const totalPower = round2((avgVolt * avgCurrent * pf * 3) / 1000);

    return {
        list_of_ahu: [
            {
                meter_id: meterId,
                meter_name: meterName,

                // Time & Status
                dtime: formattedDate,
                status: "Online",
                fan_status: "On",
                rpm: Math.round(random(900, 1400)).toString(),

                // Electrical
                avg_volt: round2Str(avgVolt),
                avg_volt_ll: round2Str(random(410, 430)),
                avg_current: round2Str(avgCurrent),
                avg_pf: round2Str(pf),
                frequency: round2Str(random(49.8, 50.2)),
                total_active_power: round2Str(totalPower),
                total_active_energy_imported: round2Str(random(80000, 90000)),

                current_r: round2Str(currentR),
                current_y: round2Str(currentY),
                current_b: round2Str(currentB),

                volt_r: round2Str(voltRN),
                volt_y: round2Str(voltYN),
                volt_b: round2Str(voltBN),
                volt_ry: round2Str(random(415, 425)),
                volt_yb: round2Str(random(415, 425)),
                volt_rb: round2Str(random(415, 425)),

                // Temperature & Humidity
                return_air_temp: round2Str(random(24, 28)),
                return_air_humi: round2Str(random(45, 65)),
                supply_air_temp: round2Str(random(14, 18)),
                supply_air_humi: round2Str(random(40, 60)),

                chilled_water_temp_in: round2Str(random(12, 15)),
                chilled_water_temp_out: round2Str(random(15, 18)),

                chilled_water_valve_percent: round2Str(random(10, 80)),
                chilled_water_valve_actual_value: round2Str(random(1000, 8000)),

                fresh_air_damper_percent: round2Str(random(10, 60)),
                fresh_air_damper_actual_value: round2Str(random(2000, 7000)),

                // IAQ
                co2: round2Str(random(450, 900)),
                tvoc: round2Str(random(20, 150)),
                formaldehyde: round2Str(random(0.05, 0.25)),
            }
        ],

        online: 1,
        offline: 0,
        total: 1,
    };
};
